export default function backdrop({ variables, }) {
    return {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: variables.popper_background,
                },
                invisible: {
                    backgroundColor: "transparent",
                },
            },
        },
    };
}
//# sourceMappingURL=backdrop.js.map